/** Inloggad projektlista (dashboard). */
export const PROJECTS_LIST_PATH = "/projects";
